<template>
    <tr class="clickable-row">
        <td v-if="showId"><a href="" @click.prevent.stop>{{order.fingerprint}}</a></td>
        <td><a href="" @click.prevent.stop>{{getDataString(order.created_date)}}</a></td>
        <td v-if="showClient"><a href="" @click.prevent.stop>{{order.client.full_name}}</a></td>
        <td>
            <a href="" @click.prevent.stop>
                <span v-for="item in order.items" v-bind:key="item.id">
                    {{item.title}}
                    <br>
                </span>
            </a>
        </td>
        <td><a href="" @click.prevent.stop><span :class="getClassLabelOrderState(order.state)" class="label">{{getStringOrderState(order.state)}}</span></a></td>
        <td><a href="" @click.prevent.stop>
            <span :class="{ label: order.payment_mode===PAYMENT_MODE.TO_PAY, 'label-danger': order.payment_mode===PAYMENT_MODE.TO_PAY }">
                {{getStringPaymentModeExtend(order.payment_mode)}}
            </span>
        </a></td>
        <td class="bold"><a href="" @click.prevent.stop>{{getCurrencySymbolFromString(order.price_currency)}}{{order.price}}</a></td>
        <td class="text-right"><button class="btn btn-default" @click="showReceiptModal"><i class="las la-receipt"></i>{{ $t('components.order.receipt') }}</button></td>
    </tr>
</template>

<script>
import {Utils} from "../../common/utils";
import {PAYMENT_MODE} from "../../common/constants";

export default {
    name: "OrderRow",
    data: () => {
        return {
            PAYMENT_MODE: PAYMENT_MODE
        }
    },
    props: {
        order: {
            type: Object,
            require: true
        },
        showId: {
            type: Boolean,
            default: true
        },
        showClient: {
            type: Boolean,
            default: true
        }
    },
    methods: {
        getDataString(date) {
            return Utils.getDateStringFromISO(date)
        },
        getStringPaymentModeExtend(payment_mode) {
            return Utils.getStringPaymentModeExtend(payment_mode)
        },
        getStringOrderState(state) {
            return Utils.getStringOrderState(state)
        },
        getClassLabelOrderState(order_state) {
            return Utils.getClassLabelOrderState(order_state)
        },
        getCurrencySymbolFromString(currency) {
            return Utils.getCurrencySymbolFromString(currency)
        },
        showReceiptModal(){
            this.$emit('show-receipt', this.order)
        }
    }
};
</script>
